import { render, staticRenderFns } from "./message_subscribe.vue?vue&type=template&id=25fc93e9&scoped=true"
import script from "./message_subscribe.vue?vue&type=script&lang=js"
export * from "./message_subscribe.vue?vue&type=script&lang=js"
import style0 from "./message_subscribe.vue?vue&type=style&index=0&id=25fc93e9&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "25fc93e9",
  null
  
)

export default component.exports